<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="14.961" height="17.098" viewBox="1181.517 769.477 14.961 17.098">
        <g data-name="Group 28">
            <path
                d="M1182.585 769.477h9.08l4.812 4.794v11.235c0 .59-.478 1.068-1.068 1.068h-12.824c-.59 0-1.068-.477-1.068-1.068v-14.96c0-.592.478-1.07 1.068-1.07Z"
                fill="#fbfbfb"
                fill-rule="evenodd"
                data-name="Path 22"
            />
            <path
                d="M1196.462 774.285h-3.725c-.59 0-1.069-.478-1.069-1.068v-3.73l4.794 4.798Z"
                fill="#8f8f8f"
                fill-rule="evenodd"
                data-name="Path 23"
            />
            <path
                d="M1192.469 777.578c.18 0 .266-.156.266-.307 0-.157-.091-.307-.266-.307h-1.02c-.199 0-.31.165-.31.347v2.505c0 .224.127.348.3.348.17 0 .298-.124.298-.348v-.688h.616c.192 0 .287-.156.287-.312 0-.152-.095-.303-.287-.303h-.616v-.935h.732Zm-3.446-.614h-.746a.33.33 0 0 0-.346.344v2.51c0 .256.207.336.355.336h.783c.926 0 1.538-.61 1.538-1.55-.001-.995-.577-1.64-1.584-1.64Zm.036 2.571h-.454v-1.953h.409c.62 0 .89.416.89.99 0 .538-.265.963-.845.963Zm-2.733-2.571h-.738c-.21 0-.326.137-.326.347v2.505c0 .224.133.348.313.348s.314-.124.314-.348v-.731h.463c.57 0 1.043-.406 1.043-1.057 0-.637-.455-1.064-1.069-1.064Zm-.012 1.532h-.425v-.944h.425c.263 0 .43.205.43.473 0 .266-.167.471-.43.471Z"
                fill="transparent"
                fill-rule="evenodd"
                data-name="Path 24"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "Pdf",
    props: ["color"],
};
</script>

<style scoped></style>
